import { createSelector } from 'reselect';
import { mapDocumentsDataToTable } from 'modules/documentsCabinet/helpers';

export const selectDocumentsCabinetStatus = (state) =>
  state.documentsCabinet?.status;

export const selectDocumentsErrorMessage = (state) =>
  state.documentsCabinet?.error?.error;

export const selectCurrentPath = (state) =>
  state.documentsCabinet?.currentPath || [];

export const selectCurrentSearch = (state) => state.documentsCabinet?.search;

export const selectDocumentsCabinetData = (state) =>
  state.documentsCabinet?.data || {};

export const selectDocumentsTableData = createSelector(
  [selectDocumentsCabinetData],
  (data) => mapDocumentsDataToTable(data)
);

export const selectDownloadingDocumentsList = (state) =>
  state.documentsCabinet?.downloadingDocumentsList;
